import { jsx as _jsx } from "react/jsx-runtime";
import { BarVisualizer } from '@livekit/components-react';
import { cn } from '@/lib/utils';
export function AudioVisualizer({ agentState, audioTrack }) {
    return (_jsx(BarVisualizer, { barCount: 5, state: agentState, trackRef: audioTrack, options: { minHeight: 5 }, className: "flex h-full w-auto items-center justify-center gap-3", children: _jsx("span", { className: cn([
                'bg-muted min-h-6 w-6 rounded-full',
                'origin-center transition-colors duration-250 ease-linear',
                'data-[lk-highlighted=true]:bg-foreground data-[lk-muted=true]:bg-muted',
            ]) }) }));
}
